import * as React from "react";

interface Props {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** The "Use Batch API" choice shared by the one-click contract summary dialogs. */
export const UseBatchApiField: React.FC<Props> = ({ id, checked, onCheckedChange, disabled = false }) => (
  <div className="flex items-start gap-2 text-sm">
    <input
      id={id}
      type="checkbox"
      className="mt-1"
      checked={checked}
      disabled={disabled}
      aria-describedby={`${id}-help`}
      onChange={event => onCheckedChange(event.target.checked)}
    />
    <div>
      <label htmlFor={id} className="font-medium">
        Use Batch API
      </label>
      <p id={`${id}-help`} className="text-slate-500">
        Cheaper, but results can take up to 24 hours.
      </p>
    </div>
  </div>
);
